"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var MeterNumberValidationHelpers = /*#__PURE__*/function () {
  function MeterNumberValidationHelpers() {
    (0, _classCallCheck2.default)(this, MeterNumberValidationHelpers);
  }
  (0, _createClass2.default)(MeterNumberValidationHelpers, null, [{
    key: "getValidatedData",
    value: function getValidatedData(register, input) {
      return this.getConvertedValue(register === null || register === void 0 ? void 0 : register.lastReadingResult, input, register);
    }
  }, {
    key: "getConvertedValue",
    value: function getConvertedValue(preMeterValue, newMeterValue, register) {
      return register.numberOfDecimalPlaces === 0 ? parseFloat(newMeterValue.split('.').join('')) : parseFloat(newMeterValue.replace(/\./g, '').replace(/,/g, '.'));
    }

    /* Replace dot with comma and put the thousand seperator  */
  }, {
    key: "getFormattedValue",
    value: function getFormattedValue(value) {
      var fixedBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!value) {
        return 0;
      }
      var newVal;
      if (fixedBy > 0) {
        newVal = value.toFixed(2);
      } else {
        newVal = value;
      }
      newVal = newVal.toString().replace(/\./g, ',');
      var parts = newVal.split(',');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      this.formattedLastReadingValue = parts.join(',');
      return this.formattedLastReadingValue;
    }
  }, {
    key: "removeRedundantZeros",
    value: function removeRedundantZeros(value) {
      if (value) {
        return value.replace(/^0+/, '');
      }
      return '';
    }
  }]);
  return MeterNumberValidationHelpers;
}();
(0, _defineProperty2.default)(MeterNumberValidationHelpers, "formattedLastReadingValue", void 0);
var _default = exports.default = MeterNumberValidationHelpers;